/* RESPONSIBLE TEAM: team-pricing-and-packaging */
import Model, { attr } from '@ember-data/model';

export default class UsageLimit extends Model {
  @attr('string') declare metric: string;
  @attr('number') declare threshold: number;
  @attr('boolean') declare enabled: boolean;
  @attr('boolean') declare limited: boolean;
}
